import React from 'react'

import {cssTheme} from '@vio/atlas/src/themes'

export const PriceTrendSimilarHotelsUp = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <path
      fill={cssTheme.colors.background.danger.tertiary}
      d="M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18Z"
    />
    <path
      stroke={cssTheme.colors.content.danger.primary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.75 25.25v-5.5m4 5.5v-7.5m4.5 7.5v-5.5m-8.5-3.5 4-4.5 4.5 4 4-5m0 14.5v-9.5"
    />
  </svg>
)
